var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isUnlocked)?_c('ModalOptionsToggleButton',{style:(_vm.styleObject),attrs:{"text":_vm.name},model:{value:(_vm.option),callback:function ($$v) {_vm.option=$$v},expression:"option"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }